import React from 'react';
import { isAppModule } from '@src/utils/constants';
import { NetworkIcon, EventsIcon, dimensionToCategory, dimensionByCategory } from './constants';

export function getIcon4SelectOption(dimensionOrCategory?: string) {
  if (!isAppModule || dimensionOrCategory === undefined) {
    return null;
  }
  let category = '';
  if (Object.prototype.hasOwnProperty.call(dimensionByCategory, dimensionOrCategory)) {
    category = dimensionOrCategory;
  } else {
    category = dimensionToCategory[dimensionOrCategory];
  }
  if (category === 'events') {
    return <EventsIcon style={{ marginRight: '3px' }} />;
  } else if (category === 'network') {
    return <NetworkIcon style={{ marginRight: '3px' }} />;
  }
  return null;
}

export function shouldDrillDownToEventPreset(groupBy: string, usecaseKey: string) {
  if (!isAppModule || usecaseKey) {
    return false;
  }
  return Object.prototype.hasOwnProperty.call(dimensionToCategory, groupBy);
}

/**
 * Check whether event related or N/W related dimensions existed on dimensionList
 */
export function includeDrilldownDimension(dimensionList: string[]) {
  return isAppModule && dimensionList.some((key) => dimensionToCategory[key] !== undefined);
}
